// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.support-page {
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: var(--bg-white);
  overflow-y: auto;
  animation: supportPageIn 0.25s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes supportPageIn {
  from {
    opacity: 0;
    transform: translateY(14px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.support-page__header {
  position: sticky;
  top: 0;
  z-index: 3;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid var(--border-soft);
}

.support-page__header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 68px;
}

.support-page__back {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: var(--font-display);
  font-size: 14px;
  font-weight: 700;
  color: var(--text-dark);
  background: transparent;
}

.support-page__back:hover {
  color: var(--teal-dark);
}

.support-page__eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: var(--font-display);
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: var(--teal-dark);
  background: var(--teal-tint);
  padding: 6px 14px;
  border-radius: 100px;
}

.support-page__audiencebar {
  position: sticky;
  top: 68px;
  z-index: 2;
  background: var(--bg-white);
  border-bottom: 1px solid var(--border-soft);
}

.support-page__audiencebar-inner {
  display: flex;
  gap: 8px;
  padding-top: 4px;
}

.support-page__audience {
  padding: 14px 18px;
  font-family: var(--font-display);
  font-size: 13.5px;
  font-weight: 700;
  color: var(--text-grey);
  background: transparent;
  border-bottom: 2.5px solid transparent;
  white-space: nowrap;
}

.support-page__audience--active.support-page__audience--teal {
  color: var(--teal-dark);
  border-bottom-color: var(--teal);
}

.support-page__audience--active.support-page__audience--amber {
  color: var(--amber-dark);
  border-bottom-color: var(--amber);
}

.support-page__body {
  padding: 40px 24px 100px;
  max-width: 640px;
}

.support-page__intro h1 {
  font-size: clamp(24px, 4vw, 32px);
  font-weight: 800;
}

.support-page__intro p {
  margin-top: 8px;
  font-size: 14.5px;
}

.support-page__types {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 24px;
}

.support-page__type {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 10px 16px;
  font-family: var(--font-display);
  font-size: 12.5px;
  font-weight: 700;
  color: var(--text-grey);
  background: var(--bg-white);
  border: 1px solid var(--border-soft);
  border-radius: 100px;
}

.support-page__type--active {
  color: #fff;
  background: var(--teal);
  border-color: var(--teal);
}

.support-page__hint {
  margin-top: 14px;
  padding: 14px 16px;
  font-size: 13px;
  line-height: 1.6;
  color: var(--text-grey);
  background: var(--bg-light);
  border-radius: var(--radius-md);
  border: 1px solid var(--border-soft);
}

.support-page__form {
  margin-top: 22px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.support-page__row {
  display: flex;
  gap: 14px;
}

.support-page__row--two {
  flex-wrap: wrap;
}

.support-page__row--two .support-page__field {
  flex: 1 1 200px;
}

.support-page__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
}

.support-page__field span {
  font-family: var(--font-display);
  font-size: 12.5px;
  font-weight: 700;
  color: var(--text-dark);
}

.support-page__field input,
.support-page__field textarea {
  width: 100%;
  padding: 13px 14px;
  font-family: var(--font-body);
  font-size: 14px;
  color: var(--text-dark);
  background: var(--bg-light);
  border: 1px solid var(--border-soft);
  border-radius: var(--radius-sm);
  resize: vertical;
}

.support-page__field input::placeholder,
.support-page__field textarea::placeholder {
  color: var(--text-mute);
}

.support-page__field input:focus,
.support-page__field textarea:focus {
  outline: none;
  border-color: var(--teal);
  background: var(--bg-white);
}

.support-page__error {
  font-size: 13px;
  font-weight: 600;
  color: var(--danger);
}

.support-page__submit {
  width: 100%;
  margin-top: 4px;
}

.support-page__submit:disabled {
  opacity: 0.65;
  cursor: default;
  transform: none !important;
}

.support-page__success {
  padding-top: 24px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.support-page__success-icon {
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--teal-tint);
  color: var(--teal-dark);
  margin-bottom: 20px;
}

.support-page__success h1 {
  font-size: 26px;
  font-weight: 800;
}

.support-page__success p {
  margin-top: 10px;
  max-width: 440px;
  font-size: 14.5px;
}

.support-page__success .btn {
  margin-top: 24px;
}

.support-page__another {
  margin-top: 14px;
  font-family: var(--font-display);
  font-size: 13px;
  font-weight: 700;
  color: var(--teal-dark);
  background: transparent;
}

.support-page__another:hover {
  text-decoration: underline;
}

@media (max-width: 640px) {
  .support-page__body {
    padding: 32px 20px 80px;
  }

  .support-page__row--two {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SupportPage.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,2BAA2B;EAC3B,gBAAgB;EAChB,4DAA4D;AAC9D;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,qCAAqC;EACrC,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;EACvB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,2BAA2B;EAC3B,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,2BAA2B;EAC3B,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,uBAAuB;EACvB,2BAA2B;EAC3B,oCAAoC;EACpC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;EACb,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;EAC5B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".support-page {\n  position: fixed;\n  inset: 0;\n  z-index: 2000;\n  background: var(--bg-white);\n  overflow-y: auto;\n  animation: supportPageIn 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n@keyframes supportPageIn {\n  from {\n    opacity: 0;\n    transform: translateY(14px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.support-page__header {\n  position: sticky;\n  top: 0;\n  z-index: 3;\n  background: rgba(255, 255, 255, 0.92);\n  backdrop-filter: blur(10px);\n  border-bottom: 1px solid var(--border-soft);\n}\n\n.support-page__header-inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 68px;\n}\n\n.support-page__back {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-family: var(--font-display);\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--text-dark);\n  background: transparent;\n}\n\n.support-page__back:hover {\n  color: var(--teal-dark);\n}\n\n.support-page__eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-family: var(--font-display);\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  color: var(--teal-dark);\n  background: var(--teal-tint);\n  padding: 6px 14px;\n  border-radius: 100px;\n}\n\n.support-page__audiencebar {\n  position: sticky;\n  top: 68px;\n  z-index: 2;\n  background: var(--bg-white);\n  border-bottom: 1px solid var(--border-soft);\n}\n\n.support-page__audiencebar-inner {\n  display: flex;\n  gap: 8px;\n  padding-top: 4px;\n}\n\n.support-page__audience {\n  padding: 14px 18px;\n  font-family: var(--font-display);\n  font-size: 13.5px;\n  font-weight: 700;\n  color: var(--text-grey);\n  background: transparent;\n  border-bottom: 2.5px solid transparent;\n  white-space: nowrap;\n}\n\n.support-page__audience--active.support-page__audience--teal {\n  color: var(--teal-dark);\n  border-bottom-color: var(--teal);\n}\n\n.support-page__audience--active.support-page__audience--amber {\n  color: var(--amber-dark);\n  border-bottom-color: var(--amber);\n}\n\n.support-page__body {\n  padding: 40px 24px 100px;\n  max-width: 640px;\n}\n\n.support-page__intro h1 {\n  font-size: clamp(24px, 4vw, 32px);\n  font-weight: 800;\n}\n\n.support-page__intro p {\n  margin-top: 8px;\n  font-size: 14.5px;\n}\n\n.support-page__types {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 24px;\n}\n\n.support-page__type {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 10px 16px;\n  font-family: var(--font-display);\n  font-size: 12.5px;\n  font-weight: 700;\n  color: var(--text-grey);\n  background: var(--bg-white);\n  border: 1px solid var(--border-soft);\n  border-radius: 100px;\n}\n\n.support-page__type--active {\n  color: #fff;\n  background: var(--teal);\n  border-color: var(--teal);\n}\n\n.support-page__hint {\n  margin-top: 14px;\n  padding: 14px 16px;\n  font-size: 13px;\n  line-height: 1.6;\n  color: var(--text-grey);\n  background: var(--bg-light);\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border-soft);\n}\n\n.support-page__form {\n  margin-top: 22px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.support-page__row {\n  display: flex;\n  gap: 14px;\n}\n\n.support-page__row--two {\n  flex-wrap: wrap;\n}\n\n.support-page__row--two .support-page__field {\n  flex: 1 1 200px;\n}\n\n.support-page__field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  flex: 1;\n}\n\n.support-page__field span {\n  font-family: var(--font-display);\n  font-size: 12.5px;\n  font-weight: 700;\n  color: var(--text-dark);\n}\n\n.support-page__field input,\n.support-page__field textarea {\n  width: 100%;\n  padding: 13px 14px;\n  font-family: var(--font-body);\n  font-size: 14px;\n  color: var(--text-dark);\n  background: var(--bg-light);\n  border: 1px solid var(--border-soft);\n  border-radius: var(--radius-sm);\n  resize: vertical;\n}\n\n.support-page__field input::placeholder,\n.support-page__field textarea::placeholder {\n  color: var(--text-mute);\n}\n\n.support-page__field input:focus,\n.support-page__field textarea:focus {\n  outline: none;\n  border-color: var(--teal);\n  background: var(--bg-white);\n}\n\n.support-page__error {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--danger);\n}\n\n.support-page__submit {\n  width: 100%;\n  margin-top: 4px;\n}\n\n.support-page__submit:disabled {\n  opacity: 0.65;\n  cursor: default;\n  transform: none !important;\n}\n\n.support-page__success {\n  padding-top: 24px;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.support-page__success-icon {\n  width: 64px;\n  height: 64px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background: var(--teal-tint);\n  color: var(--teal-dark);\n  margin-bottom: 20px;\n}\n\n.support-page__success h1 {\n  font-size: 26px;\n  font-weight: 800;\n}\n\n.support-page__success p {\n  margin-top: 10px;\n  max-width: 440px;\n  font-size: 14.5px;\n}\n\n.support-page__success .btn {\n  margin-top: 24px;\n}\n\n.support-page__another {\n  margin-top: 14px;\n  font-family: var(--font-display);\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--teal-dark);\n  background: transparent;\n}\n\n.support-page__another:hover {\n  text-decoration: underline;\n}\n\n@media (max-width: 640px) {\n  .support-page__body {\n    padding: 32px 20px 80px;\n  }\n\n  .support-page__row--two {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
